import React from 'react';
import UsersCRUD from '../components/superadmin/UsersCRUD';

const SuperadminUsersPage = () => {
  return <UsersCRUD />;
};

export default SuperadminUsersPage;

